<template>
  <div id="impact-project-milestones" class="milestones donate-carousel" v-if="product">
    <VueSlickCarousel v-bind="settings" class="milestones-wrapper">
      <div v-for="mile of milestones" 
        :key="mile.index" 
        class="mile" 
        :class="{ active: mile.index == currentMile, 'mile-lg': milestones.length > 4 }"
      >
        <div class="mile-inner-box">
          <div class="location-wrapper">
            <i class="fas fa-map-marker-alt"></i>
          </div>
          <p class="mile-index wwf-font">{{ mile.index }}</p>
          <p class="description">{{ mile.description }}</p>
          <p class="mile-step wwf-font">{{ currentStepText(mile) }}</p>
        </div>
      </div>
    </VueSlickCarousel>
  </div>
</template>

<script>
import moment from "moment";
import VueSlickCarousel from 'vue-slick-carousel';
import { mapState } from "vuex";

export default {
  name: "ImpactProjectMilestones",
  components: {
    VueSlickCarousel,
  },

  computed: {
    milestones() {
      return this.product.meta.milestones;
    },
    currentMile() {
      return this.product.meta.currentMilestone;
    },
    settings() {
      return {
        "infinite": false,
        "responsive": [
          {
            "breakpoint": 5000,
            "settings": "unslick",
          },
          {
            "breakpoint": 1024,
            "settings": {
              "slidesToShow": 3,
              "initialSlide": this.calcStartIndex(3),
            }
          },
          {
            "breakpoint": 600,
            "settings": {
              "slidesToShow": 1,
              "initialSlide": this.calcStartIndex(1),
            }
          },
        ]
      }
    },
    ...mapState({
      product: (state) => state.product.product,
    })
  },

  methods: {
    calcStartIndex(slidesToShow) {
      // Calculate starting index for carousel so 'current milestone' is in view
      // Make sure there are enough slides to fill the screen
      const mileIndex = this.currentMile - 1;
      const totalSlideCount = this.milestones.length;
      const remainingSlideCount = totalSlideCount - mileIndex;

      if (totalSlideCount < slidesToShow) {
        return 0;
      }
      if (remainingSlideCount < slidesToShow) {
        return totalSlideCount - slidesToShow;
      } 
      return mileIndex;
    },

    currentStepText(mile) {
      const current = this.currentMile;
      const { index } = mile;

      if (index == current) {
        return 'Currently working on'
      }
      if (index < current) {
        return 'GOAL ACHIEVED'
      }
      if (index > current) {
        return moment(mile.deadline).format("DD MMMM YYYY");
      }
    }
  }
};
</script>

<style scoped>
.wwf-font {
  font-family: "WWF", sans-serif;
}
.mile {
  text-align: center;
}
.mile-inner-box {
  display: grid;
  grid-template: auto 5rem minmax(4rem, 1fr) 2.5rem / 1fr;
  align-items: center;
  padding: 0.5rem;
}
.location-wrapper {
  visibility: hidden;
  font-size: 2.8rem;
  color: var(--wwfOrange);
}
.active .location-wrapper {
  visibility: visible;
}
.mile-index {
  margin-bottom: 0.5rem;
  font-size: 2.5rem;
}
.active .mile-index {
  color: var(--wwfOrange);
}
.mile-step {
  font-size: 1.5rem;
}
.description {
  height: 100%;
  align-self: start;
}
.active .description {
  border-bottom: solid 7px var(--wwfOrange);
}

.milestones >>> button.slick-arrow.slick-prev {
  left: 0;
}
.milestones >>> button.slick-arrow.slick-next {
  right: 0;
}

@media only screen and (min-width: 1025px) {
  .milestones-wrapper {
    display: flex;
    height: auto;
    flex-wrap: wrap;
    justify-content: center;
    background: none;
  }
  .mile {
    width: 25%;
  }
  .mile-lg {
    width: 33%;
  }
}
</style>


// WEBPACK FOOTER //
// ImpactProjectMilestones.vue?6b7ab2ab